module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/interface/cross-1d519dee888249b9e7e8db68dc750c3e.svg";